'use strict';
/*

    To use this input widget adapter you need to register it with your
    adapter registry.

*/

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import { createVNode, createComponentVNode } from "inferno";
import { Component } from 'inferno';
import { renderString } from './common';
import { generateId } from './utils';
import { Input } from 'inferno-bootstrap'; // Placeholder

function _getOptionsAsync(nextProps) {
  var _this = this; // TODO: How do we supply these because they could be used to get options


  var options = undefined;
  var context = undefined;
  this.props.adapter.context.getOptionsAsync(nextProps.value, options, context).then(function (results) {
    _this.setState({
      options: results
    });
  }).catch(function () {
    _this.setState({
      options: [{
        name: nextProps.value,
        title: 'Fel när data laddades...'
      }]
    });
  });
}

var SelectAsyncBaseWidget = /*#__PURE__*/function (_Component) {
  _inherits(SelectAsyncBaseWidget, _Component);

  function SelectAsyncBaseWidget(props) {
    var _this2;

    _classCallCheck(this, SelectAsyncBaseWidget);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SelectAsyncBaseWidget).call(this, props));
    _this2.state = {
      options: [{
        name: props.value,
        title: 'Laddar...'
      }]
    };
    _this2.didGetChange = _this2.didGetChange.bind(_assertThisInitialized(_assertThisInitialized(_this2)));
    return _this2;
  }

  _createClass(SelectAsyncBaseWidget, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Get new options from field
      if (nextProps.adapter.context !== this.props.adapter.context) {
        _getOptionsAsync.call(this, nextProps);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _getOptionsAsync.call(this, this.props);
    }
  }, {
    key: "didGetChange",
    value: function didGetChange(e) {
      var field = this.props.adapter.context;
      this.props.onChange(this.props.propName, field.fromString(field.valueType.fromString(e.target.value)));
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var inputName = _ref.inputName,
          namespace = _ref.namespace,
          options = _ref.options;
      var field = this.props.adapter.context;
      var isValid = this.props.validationError || this.props.invariantError ? false : undefined;
      return createComponentVNode(2, Input, {
        "type": "select",
        "id": generateId(namespace, '__Field'),
        "name": inputName,
        "aria-label": inputName || 'select',
        "aria-invalid": isValid,
        "readOnly": field.readOnly,
        "value": field.valueType.toFormattedString(field.toFormattedString(this.props.value)),
        "valid": isValid,
        "onChange": this.didGetChange,
        children: [field.placeholder && createVNode(1, "option", null, renderString(field.placeholder, options && options.lang), 0, {
          "value": ""
        }), this.state.options.map(function (item) {
          return createVNode(1, "option", null, item.title, 0, {
            "value": item.name
          });
        })]
      });
    }
  }]);

  return SelectAsyncBaseWidget;
}(Component);
/*
You need to register this widget for you custom field to make sure you get desired behaviour.

new Adapter({
    implements: IInputFieldWidget,
    adapts: IYourCustomField,
    Component: SelectAsyncBaseWidget,
})
*/


export { SelectAsyncBaseWidget as default };